module.exports = __webpack_public_path__ + "img/bannerOrange.80eeb13a.jpg";